import { PageResponseVm } from 'api/core/page-response.vm';
import { AsrsServerProductVm } from './asrs-server-product.vm';
import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';

export class GetAsrsServerProductsVm extends PageResponseVm<AsrsServerProductVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => AsrsServerProductVm)
  objects: AsrsServerProductVm[];
}
